export type DeploymentStage = 'development' | 'staging' | 'production'

const STAGES: readonly DeploymentStage[] = ['development', 'staging', 'production']

function parseDeploymentStage(raw: string | undefined): DeploymentStage | null {
  if (!raw) return null
  return STAGES.includes(raw as DeploymentStage) ? (raw as DeploymentStage) : null
}

/**
 * Baked in at build time via VITE_DEPLOYMENT_STAGE. Null if unset or invalid.
 *
 * The dev server has nothing baked in and everything it talks to is the development account,
 * so it reports development rather than nothing. Without this the staff-only CloudWatch links
 * are hidden on localhost, which is where they get used most.
 */
export function getDeploymentStage(): DeploymentStage | null {
  const staged = parseDeploymentStage(import.meta.env.VITE_DEPLOYMENT_STAGE)
  if (staged) return staged
  return import.meta.env.DEV ? 'development' : null
}

export function isProductionDeployment(): boolean {
  const stage = getDeploymentStage()
  return stage === 'production' || stage === null
}

export function allowsOrderDataClear(): boolean {
  const stage = getDeploymentStage()
  return stage === 'development' || stage === 'staging'
}

/** e.g. "development stack" — only for non-production stages. */
export function formatNonProductionStageLabel(stage: DeploymentStage): string | null {
  if (stage === 'production') return null
  return `${stage} stack`
}
